module.exports = __webpack_public_path__ + "static/media/externalLinkIcon.31114f3c.svg";